module.exports = __webpack_public_path__ + "img/hr-boiling-green-patch.023af3f9.png";